import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeDefaultColor, changeDefaultNumber } from "../../../../store/tool";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";

const LineDefaultProperyPalette = ({ line }: { line: GeometricShape }) => {
  const dispatch = useAppDispatch();
  const definitionStrokeColor = useAppSelector(state => state.tool.toolSettings.line.current.stroke)
  const definitionLineWeight = useAppSelector(state => state.tool.toolSettings.line.current.strokeWidth)
  return (
    <>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={definitionStrokeColor as ColorValue}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: "line",
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeDefaultColor(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={definitionLineWeight ?? 1}
          setValue={(number) => {
            const payload = {
              id: "line",
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeDefaultNumber(payload));
          }}
        ></NumberInput>
      </div>
    </>)
};
const createDefaultPropertyPalette = (line: GeometricShape) => {
  return <LineDefaultProperyPalette line={line} />;
};
export default createDefaultPropertyPalette;
